import React from 'react';
import './Sidebar.css';

const Sidebar = ({ current, onNavigate }) => {
  const items = [
    { key: 'dashboard', label: 'Dashboard' },
    { key: 'users', label: 'Users' },
    { key: 'products', label: 'Products' },
    { key: 'positions', label: 'Positions' },
  ];

  return (
    <div className="sidebar">
      {items.map(item => (
        <div
          key={item.key}
          className={`sidebar-item ${current === item.key ? 'active' : ''}`}
          onClick={() => onNavigate(item.key)}
        >
          {item.label}
        </div>
      ))}
    </div>
  );
};

export default Sidebar;
